import Image, { ImageProps, ImageLoaderProps } from 'next/image';

import { urlSafeBase64 } from 'utils/helpers';

export interface ImageProxyProps {
  sourceWidth?: number;
  sourceHeight?: number;
  // https://github.com/imgproxy/imgproxy/blob/master/docs/generating_the_url.md#resizing-type
  resizingType?: 'auto' | 'fit' | 'fill' | 'fill-down' | 'force';
  // https://github.com/imgproxy/imgproxy/blob/master/docs/generating_the_url.md#gravity
  gravityType?:
    | 'no'
    | 'so'
    | 'ea'
    | 'we'
    | 'noea'
    | 'nowe'
    | 'soea'
    | 'sowe'
    | 'ce';
  // https://github.com/imgproxy/imgproxy/blob/master/docs/image_formats_support.md#image-formats-support
  extension?: 'png' | 'jpg' | 'webp';
}

export const buildImgProxyUrl = (
  resizingType: ImageProxyProps['resizingType'],
  width: number,
  height: number,
  enlarge: number,
  gravityType: ImageProxyProps['gravityType'],
  quality: number,
  src: string,
  extension?: ImageProxyProps['extension']
) => {
  const host = process.env.NEXT_PUBLIC_CDN_HOST as string;
  const encodedUrl = urlSafeBase64(src);

  return `${host}/insecure/rs:${resizingType}:${width}:${height}:${enlarge}/g:${gravityType}/q:${quality}/${encodedUrl}.${
    extension || 'webp'
  }`;
};

export default function ImageProxy(props: ImageProxyProps & ImageProps) {
  const { width, height } = props;
  const {
    resizingType = 'fit',
    extension = 'webp',
    gravityType = 'no',
    sourceWidth,
    sourceHeight,
    ...imageProps
  } = props;

  // лоадер для формирования ссылки до изображения через imgproxy
  // https://github.com/imgproxy/imgproxy/blob/master/docs/generating_the_url.md
  const imgProxyLoader = ({ src, quality }: ImageLoaderProps) => {
    const imgWidth = (width || sourceWidth || 300) as number;
    const imgHeight = (height || sourceHeight || 300) as number;
    const imgQuality = quality || 0;
    const enlarge = 0;

    return buildImgProxyUrl(
      resizingType,
      imgWidth,
      imgHeight,
      enlarge,
      gravityType,
      imgQuality,
      src,
      extension
    );
  };

  return <Image loader={imgProxyLoader} {...imageProps} />;
}
